import { Outlet, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Calendar, LogOut } from 'lucide-react';

export function Layout() {
    const { user, logout } = useAuth();

    return (
        <div className="min-h-screen">
            <header className="header">
                <div className="container header-content">
                    <Link to="/dashboard" className="header-logo">
                        <Calendar style={{ display: 'inline', marginRight: '8px' }} />
                        AAM <span>Let's Meet</span>
                    </Link>

                    {/* Navigation links removed per user request */}

                    <div className="header-user">
                        <span style={{ opacity: 0.8, fontSize: '0.875rem' }}>
                            {user?.name || user?.email}
                        </span>
                        <button
                            onClick={logout}
                            className="btn btn-ghost"
                            style={{ color: 'white', padding: '8px' }}
                            title="Sign out"
                        >
                            <LogOut size={18} />
                        </button>
                    </div>
                </div>
            </header>

            <main>
                <Outlet />
            </main>
        </div>
    );
}
